import { render, staticRenderFns } from "./ConfigCreditCards.vue?vue&type=template&id=65e96c8d&scoped=true"
import script from "./ConfigCreditCards.vue?vue&type=script&lang=js"
export * from "./ConfigCreditCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e96c8d",
  null
  
)

export default component.exports